import { makeStyles } from "@mui/styles";

import { palette } from "../../../theme/palette";

import DepotSummary from "../../DepotSummary";
import LockComponent from "./LockComponent";
import { View } from "../../View";

const useStyles = makeStyles(({ typography }) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    height: typography.pxToRem(30),
    width: "100vw",
    backgroundColor: palette.transparent,
  },
  rightActions: {
    marginLeft: "auto",
    display: "flex",
    alignItems: "center",
  },
  leftContent: {
    display: "inline-block",
  },
}));

export const Subheader = () => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <View className={styles.leftContent}>
        <DepotSummary />
      </View>
      <View className={styles.rightActions}>
        <LockComponent />
      </View>
    </View>
  );
};
